<template>
  <b-container class="text-left">
    <h1 class="mb-5">Rendszerüzenetek</h1>
    <h2 class="mb-4">Címzett csoportok</h2>
    <section v-if="this.userGroupList.length > 0">
      <b-row class="mb-4">
        <b-col v-for="userGroup in this.userGroupList" :key="userGroup._id" md="6">
          <UserGroupItem :userGroup="userGroup" @refresh-list="handleRefresh($event)" />
        </b-col>
      </b-row>
    </section>
    <section v-else class="d-flex no-user-group-wrapper">
      <div class="col-6 d-flex align-items-center justify-content-center">
        <b-row class="ml-2">
          <p class="no-user-group-text">Még nincsenek címzett csoportok!</p>
          <p>Az új csoport létrehozása gombbal hozzon létre egyet.</p>
        </b-row>
      </div>
      <div class="col-6">
        <img src="../../assets/img/user-group-empty.png" alt="user-group-background" class="background-image" />
      </div>
    </section>

    <p class="cursor-pointer mt-5" @click="navigateTo('/system-email/create-group')">
      <strong class="add-more"> + Új csoport létrehozása </strong>
    </p>
  </b-container>
</template>

<script>
import * as systemEmailsApi from '../../api/systemEmail'
import UserGroupItem from './components/UserGroupItem.vue'
export default {
  data() {
    return {
      userGroupList: []
    }
  },
  components: { UserGroupItem },
  methods: {
    navigateTo(link) {
      this.$router.push(link)
    },
    async getAllUserGroup() {
      const result = await systemEmailsApi.getAllUserGroup()
      this.userGroupList = result
    },
    handleRefresh(value) {
      if (value === true) {
        this.getAllUserGroup()
      }
    }
  },
  async created() {
    this.getAllUserGroup()
  }
}
</script>

<style lang="scss" scoped>
.no-user-group-wrapper {
  padding: 20px;
  padding-top: 30px;
  min-height: 80px;
  background-color: #f7fbfc;
  min-height: 80px;
  margin-bottom: 10px;
}
.no-user-group-text {
  font-family: 'Roboto';
  font-style: normal;
  font-weight: 400;
  font-size: 24px;
  color: #00903c;
}
.background-image {
  width: 100%;
}

.add-more {
  font-family: 'Roboto';
  font-style: normal;
  font-weight: 500;
  font-size: 14px;
  line-height: 24px;
  color: #00903c;
  cursor: pointer;
  display: flex;
  justify-content: end;
}
</style>
